"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAui, AuiProvider, Derived } from "@assistant-ui/store";
import { ThreadListItemClient } from "../../legacy-runtime/client/ThreadListItemRuntimeClient.js";
export const ThreadListItemByIndexProvider = ({ index, archived, children }) => {
    const aui = useAui({
        threadListItem: Derived({
            source: "threads",
            query: { type: "index", index, archived },
            get: (aui) => aui.threads().item({ index, archived }),
        }),
    });
    return _jsx(AuiProvider, { value: aui, children: children });
};
export const ThreadListItemRuntimeProvider = ({ runtime, children }) => {
    const aui = useAui({
        threadListItem: ThreadListItemClient({ runtime }),
    });
    return _jsx(AuiProvider, { value: aui, children: children });
};
//# sourceMappingURL=ThreadListItemProvider.js.map